import { recordClientActivity } from "@/api/orval/client-activity/client-activity";
import { LanguageCode } from "@/api/orval/model";

import type { ClientActivitySend } from "./types";

const KEEPALIVE_REQUEST_OPTIONS = {
  adapter: "fetch",
  fetchOptions: { keepalive: true },
} as const;

export const sendClientActivity: ClientActivitySend = async (entries, { keepalive }) => {
  await recordClientActivity(
    { entries, requestedLanguageCode: LanguageCode.NUMBER_0 },
    keepalive ? KEEPALIVE_REQUEST_OPTIONS : undefined,
  );
};
